import moment, { type Moment } from "moment";

const DATE_FORMAT_LITERAL_REGEX = /\[[^\]]*\]/g;
const DATE_FORMAT_TIME_TOKEN_REGEX = /[HhmsSAaZz]/;

export interface ParsedCsvDate {
  date: Moment;
  matchedFormat: string | undefined;
}

/**
 * Splits a mapping's date format field into ordered, non-empty Moment formats.
 */
export const splitCsvDateFormats = (sourceFormats: string | undefined): string[] =>
  String(sourceFormats || "")
    .split(",")
    .map((format) => format.trim())
    .filter(Boolean);

/**
 * Strictly parses a CSV date by trying each configured format in order.
 */
export const parseCsvDateWithFormats = (source: string, sourceFormats: string): ParsedCsvDate => {
  for (const format of splitCsvDateFormats(sourceFormats)) {
    const date = moment.utc(source, format, true);
    if (date.isValid()) return { date, matchedFormat: format };
  }

  return { date: moment.invalid(), matchedFormat: undefined };
};

/**
 * Reports whether a Moment format includes a time component outside literals.
 */
export const csvDateFormatIncludesTime = (sourceFormat: string | undefined): boolean =>
  Boolean(sourceFormat && DATE_FORMAT_TIME_TOKEN_REGEX.test(sourceFormat.replace(DATE_FORMAT_LITERAL_REGEX, "")));
